import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomerDetails } from 'src/app/services_autogenerated/generated_services';

@Component({
  selector: 'app-display-customer-info',
  templateUrl: './display-customer-info.component.html',
  styleUrl: './display-customer-info.component.css',
  standalone: false
})
export class DisplayCustomerInfoComponent {
  @Input() customer!: CustomerDetails;
  @Input() canSelectContacts: boolean = false;

  @Output() contactChangeEvent = new EventEmitter<number[]>();

  selectedContacts: number[] = [];

  onChange() {
    this.contactChangeEvent.emit(this.selectedContacts);
  }
}
